// extracted by mini-css-extract-plugin
module.exports = {"container":"Columns__container___2Lz3G","column":"Columns__column___3oCF9","rigid":"Columns__rigid___3XdLr","centered":"Columns__centered___11Vw-"};